import { api } from './api';

export type LearnChapter = { at: number; label: string };

export type LearnVideo = {
  id: string;
  title: string;
  description: string;
  recorded_on: string;
  duration_seconds: number;
  chapters: LearnChapter[];
  /** Presigned, short-lived; refetch rather than store it. */
  url: string;
};

export const learnService = {
  async getLearnVideos(): Promise<LearnVideo[]> {
    const { data } = await api.get<LearnVideo[]>('/learn/videos');
    return data;
  },
};
